import React from 'react';
import { FormattedMessage } from 'react-intl';
import { createCookie, legalUrl } from '../../app/AppHelpers';
import './cookies.css';

class Cookies extends React.Component {
  constructor(props) {
    super(props);
    this.state = { cookiesAccepted: false }
  }

  hideCookies = () => {
    this.setState({ cookiesAccepted: true });
    createCookie('cookiesAccepted', 1);
  }

  render() {
    return !this.state.cookiesAccepted && renderCookiesWarning(this.hideCookies)
  }
}

const renderCookiesWarning = (hideCookiesF) => {
  return (<div className='cookies'>
    <p><FormattedMessage id="CookiesBanner.firstSection" defaultMessage="Cookies: This website uses cookies" />
      <a href={legalUrl() + "cookies-terms.html"} target="_blank">
        <FormattedMessage id="Contact.linkToCookies" defaultMessage="cookies policy" />
      </a></p>
    <button onClick={() => hideCookiesF()}>
      <FormattedMessage id="CookiesBanner.buttonAccept" defaultMessage="Accept" />
    </button>
  </div>
  );
}

export default Cookies;



// WEBPACK FOOTER //
// ./src/containers/cookies/Cookies.js